import * as path from 'path';
import pkg from '@workbench-stack/platform/lib/package';
import product from '../product';
import * as crypto from 'crypto';
import { isWindows, isLinux } from '@vscode/base-node/vs/base/common/platform';


// Read this before there's any chance it is overwritten
// Related to https://github.com/Microsoft/vscode/issues/30624
const xdgRuntimeDir = process.env['XDG_RUNTIME_DIR'];

export function getUniqueUserId(): string {
    let username: string;
    if (process.platform === 'win32') {
        username = process.env.USERNAME;
    } else {
        username = process.env.USER;
    }

    if (!username) {
        return ''; // fail gracefully if there is no user name
    }

    // use sha256 to ensure the userid value can be used in filenames and are unique
    return crypto.createHash('sha256').update(username).digest('hex').substr(0, 6);
}

export function getNixIPCHandle(userDataPath: string, type: string): string {
    if (xdgRuntimeDir) {
        const scope = crypto.createHash('md5').update(userDataPath).digest('hex').substr(0, 8);
        return path.join(xdgRuntimeDir, `vscode-${scope}-${pkg.version}-${type}.sock`);
    }

    return path.join(userDataPath, `${pkg.version}-${type}.sock`);
}

export function getWin32IPCHandle(type: string): string {
    // Support to run VS Code multiple times as different user
    // by making the socket unique over the logged in user
    const userId = getUniqueUserId();
    const name = product.applicationName + (userId ? `-${userId}` : '');

    return `\\\\.\\pipe\\${name}-${pkg.version}-${type}-sock`;
}

export function getIPCHandle(userDataPath: string, type: string): string {
    if (process.platform === 'win32') {
        return getWin32IPCHandle(type);
    } else {
        return getNixIPCHandle(userDataPath, type);
    }
}

function getCLIPath(execPath: string, appRoot: string, isBuilt: boolean): string {

    // Windows
    if (isWindows) {
        if (isBuilt) {
            return path.join(path.dirname(execPath), 'bin', `${product.applicationName}.cmd`);
        }

        return path.join(appRoot, 'scripts', 'code-cli.bat');
    }

    // Linux
    if (isLinux) {
        if (isBuilt) {
            return path.join(path.dirname(execPath), 'bin', `${product.applicationName}`);
        }

        return path.join(appRoot, 'scripts', 'code-cli.sh');
    }

    // macOS
    if (isBuilt) {
        return path.join(appRoot, 'bin', 'code');
    }

    return path.join(appRoot, 'scripts', 'code-cli.sh');
}
